
export const PRODUCT_CONFIG = {'learnHeader': 'Are you sure?' };
export const PRODUCT_CONFIGURATOR_QTY_LIMIT = 99999;
export const ASSIGN_USER_LIMIT = 20;
